/* istanbul ignore file */
import AddressForm from './AddressForm';

export default AddressForm;
